<template>
  <div id="reporting-widget">
    <!--    Changes made for AAAS-4626 to make it 'skinny'. Keeping code that formats full
        screen widget for future development-->
    <!--    <section v-if="layout === 'threecol'" :class="layout">-->
    <!--      <ReportingArea :name="layouts[layout]['areas'][0]">-->
    <!--        <ReportBuilder class="report-builder"></ReportBuilder>-->
    <!--      </ReportingArea>-->
    <!--    </section>-->
    <ReportBuilder class="report-builder"></ReportBuilder>
  </div>
</template>

<script>
import ReportBuilder from "@/components/reporting/ReportBuilder.vue";

export default {
  name: "Reporting",
  components: {
    ReportBuilder: () => import("@/components/reporting/ReportBuilder"),
    // ReportingArea: () => import("@/components/reporting/ReportingArea"),
  },
  data: () => ({
    layout: "threecol",
    //The named areas of each layout
    layouts: {
      threecol: {
        areas: ["A", "B0", "B1", "C"],
      },
    },
  }),
  computed: {
    countries() {
      let countries = [];
      this.regions?.forEach((region) => {
        countries = countries.concat(region.countries);
      });
      countries.sort((a, b) => a.text.localeCompare(b.text));
      return countries;
    },
  },
  methods: {},
};
</script>

<style scoped>
#reporting-widget {
  width: 300px;
  height: calc(100vh - 100px);
}
[draggable="true"] {
  cursor: grab;
}

/* "threecol Four" layout */
.threecol {
  max-height: 100%;
  display: grid;
  grid-template-columns: 33% 33% 33%;
  grid-template-rows: 50% 50%;
  grid-template-areas:
    "A B0 C"
    "A B1 C";
}
.report-builder {
  min-width: 300px;
}
</style>
